import script from "./TicketDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./TicketDetailsView.vue?vue&type=style&index=0&id=5a8e4a8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8e4a8a"]])

export default __exports__